import React from 'react'
import styles from './Loading.module.scss'

function EmptySpan() {
  return <span className={styles.emptySpan}>&nbsp;</span>
}

function EmptySpanHeader() {
  return <span className={styles.emptySpanHeader}>&nbsp;</span>
}

interface Props {
  rows?: number
}

export default function Loading({ rows = 10 }: Props) {
  return (
    <table className={styles.table} cellPadding={0} cellSpacing={0}>
      <thead>
        <tr>
          <th><EmptySpanHeader /></th>
          <th><EmptySpanHeader /></th>
          <th><EmptySpanHeader /></th>
          <th><EmptySpanHeader /></th>
        </tr>
      </thead>
      <tbody>
        {Array(rows).fill(0).map((_, index) => (
            <tr key={index}>
              <td><EmptySpan /></td>
              <td><EmptySpan /></td>
              <td><EmptySpan /></td>
              <td><EmptySpan /></td>
            </tr>
          ),
        )}
      </tbody>
    </table>
  )
}